<template>
  <!-- 表单区域 -->
  <div class="form-container">
    <div class="logo-wrapper">
      <img class="logo-img" :src="this.$store.getters.getBaseInfo.login_ico !==undefined ?this.$store.getters.getBaseInfo.login_ico:'/img/null.png'">
    </div>
    <p class="form-title">{{$t("请填写所有信息以创建帐户。")}}</p>

      <!-- 用户名 -->
      <div class="form-group">
        <label class="form-label" for="username">{{$t("登录帐户名称")}}</label>
        <div class="input-wrapper">
          <img src="/img/login/account.jpg" class="icon">
          <input type="text" id="username" v-model="username" class="form-input" :placeholder="$t('输入帐户名称')">
        </div>
        <span class="form-hint">{{$t("6-20个字符，无符号，无特殊字符")}}</span>
      </div>

      <!-- 密码 -->
      <div class="form-group">
        <label class="form-label" for="password">{{$t("密码")}}</label>
        <div class="input-wrapper">
          <img src="/img/login/lock.jpg" class="icon">
          <input :type="passwordType" v-model="password" class="form-input" :placeholder="$t('输入密码')">
          <img src="/img/login/eye-off.jpg" v-if="passwordType === 'password'" class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType">
          <img src="/img/login/eye.jpg" v-else class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType">
        </div>
        <span class="form-hint">{{$t("8-20个字符，包括大写、小写、数字和特殊字符")}}</span>
      </div>

      <!-- 确认密码 -->
      <div class="form-group">
        <label class="form-label" for="confirm_password">{{ $t("验证密码") }}</label>
        <div class="input-wrapper">
          <img src="/img/login/lock.jpg" class="icon">
          <input  v-model="password1" :type="passwordType1" id="confirm_password" class="form-input" :placeholder="$t('重新输入密码')">
          <img src="/img/login/eye-off.jpg" v-if="passwordType1 === 'password'" class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType1">
          <img src="/img/login/eye.jpg" v-else class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType1">
        </div>
      </div>

      <!-- 二级密码 -->
      <div class="form-group">
        <label class="form-label" for="password2">{{ $t("创建二级密码") }}</label>
        <div class="input-wrapper">
          <img src="/img/login/lock.jpg" class="icon">
          <input id="password2" v-model="paypass" :type="passwordType2" class="form-input" :placeholder="$t('输入二级密码')">
          <img src="/img/login/eye-off.jpg" v-if="passwordType2 === 'password'" class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType2">
          <img src="/img/login/eye.jpg" v-else class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType2">
        </div>
        <span class="form-hint">{{ $t("8-20个字符，包括大写、小写、数字和特殊字符") }}</span>
      </div>

      <!-- 确认二级密码 -->
    <div class="form-group">
      <label class="form-label" for="confirm_password2">{{ $t("二级密码验证") }}</label>
      <div class="input-wrapper">
        <img src="/img/login/lock.jpg" class="icon">
        <input v-model="paypass1" :type="passwordType3"  class="form-input" :placeholder="$t('重新输入二级密码')">
        <img src="/img/login/eye-off.jpg" v-if="passwordType3 === 'password'" class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType3">
        <img src="/img/login/eye.jpg" v-else class="fa-regular fa-eye-slash password-toggle icon" @click="switchPasswordType3">
      </div>
    </div>

      <!-- 邀请码 -->
      <div class="form-group">
        <label class="form-label" for="referral_code">{{ $t("邀请码") }}</label>
        <div class="input-wrapper">
          <img src="/img/login/gift.jpg" class="icon">
          <input type="text"  v-model="code" class="form-input" :placeholder="$t('输入邀请代码')">
        </div>
      </div>

      <!-- 协议同意 -->
      <div class="terms-group">
        <input type="checkbox" :checked="checked" @click="checked = !checked">
        <div  @click="checked = !checked">
          {{ $t("我已经阅读并同意") }} <span >{{ $t("使用条款") }}</span> {{ $t("和") }} <span >{{ $t("隐私政策") }}</span>
          {{ $t("来自Vietlott") }}
        </div>
      </div>

      <!-- 注册按钮 -->
      <button type="submit" class="submit-btn" @click="doRegister">{{ $t("register.doRegister") }}</button>

    <!-- 分割线与注册 -->
    <div class="divider">{{$t("有帐户？")}}</div>
    <button type="button" class="register-btn" @click="toLogin">{{$t("login.doLogin")}}</button>

  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      password: this.inputValue,
      password1: "",
      paypass: "",
      paypass1: "",
      passwordType: 'password',
      passwordType1: 'password',
      passwordType2: 'password',
      passwordType3: 'password',
    };
  },
  methods: {

    //客服
    service() {
      window.location.href = this.$store.getters.getBaseInfo.kefu;
    },
    filterSpaces(event) {
      this.username = event.replace(/[^a-zA-Z0-9]/g, '');
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    switchPasswordType1() {
      this.passwordType1 = this.passwordType1 === 'password' ? 'text' : 'password'
    },
    switchPasswordType2() {
      this.passwordType2 = this.passwordType2 === 'password' ? 'text' : 'password'
    },
    switchPasswordType3() {
      this.passwordType3 = this.passwordType3 === 'password' ? 'text' : 'password'
    },
    toLogin(){
      this.$router.push("Login")
    },
    doRegister() {


      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast(this.$t('输入帐户名称')+"!");
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast(this.$t('输入密码')+"!");
        return false;
      }
      if(this.password1 === "" || this.password1 === null || this.password1 === undefined){
        this.$toast(this.$t('重新输入密码')+"!");
        return false;
      }
      if(this.paypass === "" || this.paypass === null || this.paypass === undefined){
        this.$toast(this.$t('输入二级密码')+"!");
        return false;
      }
      if(this.paypass1 === "" || this.paypass1 === null || this.paypass1 === undefined){
        this.$toast(this.$t('重新输入二级密码')+"!");
        return false;
      }
      if(this.password1 != this.password){
        this.$toast(this.$t('重新输入密码不正确')+"!");
        return false;
      }

      if(this.paypass != this.paypass1){
        this.$toast(this.$t('二级密码不一致')+"!");
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast(this.$t('输入邀请代码')+"!");
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t('register.chooseAgreement'));
        return false;
      }
      this.$http({
        method: 'get',
        data:{
          username:this.username,
          password:this.password,
          paypass: this.paypass,
          code:this.code
        },
        url: 'member_register'
      }).then(res=>{
          if(res.code === 200){
            this.$toast.success(this.$t("msg."+res.msg));
            localStorage.setItem('token1',res.data.token)
            localStorage.setItem('token',res.data.id)
            this.$router.push("Mine")
          }else {
            this.$toast.fail(this.$t("msg."+res.msg));
          }
      })
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.fa-regular{
  margin-right: 10px;
}
.logo-wrapper{
  margin: 0 auto;
  width: 45%;
}
.logo-wrapper .logo-img{
  width: 100%;
  margin-top: 40px;
}
.icon{
  width: 20PX;
  margin-left: 10PX;
}
/* 容器样式，模拟移动端视图 */
.container {
  max-width: 480PX;
  margin: 0 auto;
  background-color: #fff;
  min-height: 100vh;
  position: relative;
  box-shadow: 0 0 10PX rgba(0,0,0,0.05);
}

/* 顶部红色 Header */
.header {
  background: linear-gradient(180deg, #e60012 0%, #c00010 100%);
  padding: 25PX 20PX;
  text-align: center;
  color: white;
  position: relative;
}

.logo {
  font-size: 32PX;
  font-weight: bold;
  letter-spacing: 1PX;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10PX;
}

.logo-icon {
  font-style: normal;
  width: 30PX;
  height: 30PX;
  background: white;
  color: #e60012;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18PX;
}

.slogan {
  font-size: 14PX;
  margin-top: 5PX;
  opacity: 0.9;
}

/* 表单区域 */
.form-container {
  padding: 20PX;
  background-color: #fff;
  border-radius: 8PX;
  margin-top: -10PX; /* 轻微覆盖header底部营造层次感 */
  position: relative;
  z-index: 10;
}

.form-title {
  text-align: center;
  font-size: 15PX;
  color: #666;
  margin-bottom: 20PX;
  font-weight: 500;
}

.form-group {
  margin-bottom: 15PX;
}

.form-label {
  display: block;
  font-size: 14PX;
  font-weight: bold;
  color: #444;
  margin-bottom: 8PX;
}

/* 输入框包裹层，用于定位图标 */
.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  border: 1PX solid #ddd;
  border-radius: 6PX;
  background-color: #fff;
  transition: border-color 0.3s;
}

.input-wrapper:focus-within {
  border-color: #e60012;
}

.input-icon {
  position: absolute;
  left: 12PX;
  color: #999;
  font-size: 16PX;
  z-index: 1;
}

.form-input {
  width: 100%;
  padding: 12PX 10PX 12PX 10PX;
  border: none;
  outline: none;
  font-size: 15PX;
  border-radius: 6PX;
  background: transparent;
}

.toggle-password {
  position: absolute;
  right: 12PX;
  color: #999;
  cursor: pointer;
  font-size: 16PX;
}

.form-hint {
  font-size: 12PX;
  color: #888;
  margin-top: 6PX;
  display: block;
}

/* 邀请码特殊样式 */
.gift-icon {
  color: #e60012;
}

/* 协议勾选区域 */
.terms-group {
  display: flex;
  align-items: center;
  margin-top: 20PX;
  margin-bottom: 20PX;
  font-size: 14PX;
  color: #444;
}

.terms-group input[type="checkbox"] {
  width: 18PX;
  height: 18PX;
  margin-right: 8PX;
  accent-color: #e60012;
  cursor: pointer;
}

.terms-group span {
  color: #e60012;
  text-decoration: none;
  font-weight: bold;
}

/* 注册按钮 */
.submit-btn {
  width: 100%;
  padding: 14PX;
  background-color: #e60012;
  color: white;
  border: none;
  border-radius: 6PX;
  font-size: 16PX;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s;
}

.submit-btn:hover {
  background-color: #c00010;
}

/* 右下角悬浮按钮 */
.fab {
  position: fixed;
  bottom: 20PX;
  right: 20PX;
  width: 45PX;
  height: 45PX;
  background-color: #f0f0f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2PX 5PX rgba(0,0,0,0.2);
  cursor: pointer;
  color: #666;
  font-size: 18PX;
  z-index: 100;
}
/* 分割线和注册区域 */
.divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #999;
  font-size: 13PX;
  margin-bottom: 20PX;
  margin-top: 20PX;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  border-bottom: 1PX solid #ddd;
}

.divider:not(:empty)::before {
  margin-right: .5em;
}

.divider:not(:empty)::after {
  margin-left: .5em;
}

.register-btn {
  width: 100%;
  background-color: #fff;
  color: #d8000f;
  border: 1PX solid #d8000f;
  padding: 14PX;
  border-radius: 8PX;
  font-size: 16PX;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}

.register-btn:hover {
  background-color: #fff5f5;
}
</style>
